import clsx from "clsx";
import { type Dispatch, type JSX, type SetStateAction, useState } from "react";

import type { PRICING_PLANS } from "features/subscriptions/constants";

import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";

import SubscriptionTypeCards from "./SubscriptionTypeCards";

import LockedIcon from "assets/icons/locked.svg?react";

interface MobileLayoutProps {
  title: string;
  subscriptionType: keyof typeof PRICING_PLANS;
  setSubscriptionType: Dispatch<SetStateAction<keyof typeof PRICING_PLANS>>;
  actionButton: JSX.Element;
}

export default function MobileLayout({
  title,
  subscriptionType,
  setSubscriptionType,
  actionButton,
}: MobileLayoutProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  let coverImage = "bg-[url(/assets/images/plans/outreach-cover.webp)]";

  if (subscriptionType === "rental") {
    coverImage = "bg-[url(/assets/images/plans/avatar-cover.webp)]";
  } else if (subscriptionType === "agency") {
    coverImage = "bg-[url(/assets/images/plans/agency-cover.webp)]";
  }

  return (
    <>
      <div className="flex items-center justify-center flex-col grow p-4">
        <LockedIcon className="mb-7" />
        <h2 className="text-xl-bold mb-1.5">Page locked</h2>
        <p className="text-black-500 text-sm mb-4">
          {title}. Choose a plan to proceed
        </p>
        <Button onClick={() => setIsDrawerOpen(true)}>Continue</Button>
      </div>

      <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
        <DrawerContent>
          <DrawerHeader title={title} subtitle="Choose a plan to proceed:" />

          <DrawerBody className="gap-y-4">
            <SubscriptionTypeCards
              subscriptionType={subscriptionType}
              setSubscriptionType={setSubscriptionType}
            />

            <div
              className={clsx(
                "flex flex-col bg-white justify-between bg-cover bg-center h-98 p-4 lg:w-88 rounded-5xl lg:border-4 border-black-200 lg:shadow-2xl",
                coverImage,
              )}
            ></div>
          </DrawerBody>

          <DrawerFooter className="justify-end">
            <DrawerClose asChild>
              <Button variant="secondary-black">Cancel</Button>
            </DrawerClose>
            {actionButton}
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
